<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">

  <form class="form-wrapper" [formGroup]="projektForm">

    <div class="eineLinie">
      <mat-form-field class="shortField" appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.projektDialog.stufenname' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.projektverwaltung.projektDialog.stufenname' | translate"
          formControlName="name"
        />
        <mat-error *ngIf="projektForm.controls.name.invalid">{{ getErrorMessage('name') | translate }}</mat-error>
      </mat-form-field>
    </div>
    <mat-form-field class="shortField"  appearance="outline">
      <mat-label>{{ 'pages.projektverwaltung.projektDialog.mitarbeiter' | translate }}</mat-label>
      <mat-select formControlName="mitarbeiter" multiple>
        <mat-option *ngFor="let mitarbeiter of ($mitarbeiter |async)" [value]="mitarbeiter.id">{{mitarbeiter.name + " " + mitarbeiter.vorname + "  " + mitarbeiter.ort + " " + mitarbeiter.plz}}</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
    [tabIndex]="-1"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="projektForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>

</mat-dialog-actions>
